module.exports = __webpack_public_path__ + "static/media/contacto.cd31742f.svg";